"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setFlyoutPosition = exports.handleFocusElement = exports.getModalRoot = void 0;
var _getElementDimensions = _interopRequireDefault(require("./getElementDimensions"));
var _getElementPosition = _interopRequireDefault(require("./getElementPosition"));
/* returns the modalRoot element.. or creates it first if it doesn't exist. */
/* used to open modal and flyout elements outside the normal react scope. */
const getModalRoot = () => {
  const rootId = "ModalFlyout-root";
  if (!document.getElementById(rootId)) {
    let el = document.createElement("div");
    el.setAttribute("id", rootId);
    document.body.appendChild(el);
  }
  return document.getElementById(rootId);
};

/* setFlyoutPosition */
/* calculates the flyout elemens position relative to a target/anchor element */
/* returns a set of css rules in a style Object format */

/* must pass in the following:
   @anchorElem: an element reference
   @alignment: one of six positioning targets [topLeft, topRight, topCentered, bottomLeft, bottomRight, bottomCentered]
   @offset: an x/y object to adjust target elements position. relates to margin +/- 
   @pointerOffset: a numeric value to add extra top/bottom margin to account for a bubble pointer 
*/
exports.getModalRoot = getModalRoot;
const setFlyoutPosition = function (anchorElem) {
  let alignment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "bottomLeft";
  let offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    x: 0,
    y: 0
  };
  let pointerOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  let isFixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  if (!anchorElem) {
    return {};
  }
  let pos = (0, _getElementPosition.default)(anchorElem);
  let dim = (0, _getElementDimensions.default)(anchorElem);
  let bodyDim = {};
  if (isFixedPosition) {
    bodyDim = {
      w: window.innerWidth || document.documentElement.clientWidth,
      h: window.innerHeight || document.documentElement.clientHeight
    };
  } else {
    bodyDim = (0, _getElementDimensions.default)(document.body);
  }
  let y; // vert pos
  let x; // hort pos
  let t; // transform pos for "top[x]" alignements

  const offsetX = offset.x || 0;
  const offsetY = offset.y || 0;
  let positionStyles = {};
  switch (alignment) {
    case "leftBottom":
      y = pos.y;
      x = bodyDim.w - pos.x;
      t = `translateY(calc(-100%))`;
      positionStyles = {
        top: y,
        right: x,
        marginRight: pointerOffset * 2,
        marginTop: pointerOffset * 4,
        transform: t
      };
      break;
    case "leftTop":
      y = pos.y;
      x = bodyDim.w - pos.x;
      positionStyles = {
        top: y,
        right: x,
        marginRight: pointerOffset * 2,
        marginTop: -pointerOffset * 1.5
      };
      break;
    case "leftMiddle":
      y = pos.y;
      x = bodyDim.w - pos.x;
      t = `translateY(calc(-50%))`;
      positionStyles = {
        top: y,
        right: x,
        marginRight: pointerOffset * 2,
        marginTop: offsetY + 6,
        // 6 = 1/2 pointer height
        transform: t
      };
      break;
    case "topLeft":
      y = pos.y;
      x = pos.x;
      t = `translateY(calc(-100% + -${dim.h}px)`;
      positionStyles = {
        top: y,
        left: x,
        marginLeft: offsetX,
        marginTop: offsetY - pointerOffset,
        transform: t
      };
      break;
    case "topRight":
      y = pos.y;
      x = bodyDim.w - (pos.x + dim.w);
      t = `translateY(calc(-100% + -${dim.h}px)`;
      positionStyles = {
        top: y,
        right: x,
        marginRight: offsetX,
        marginTop: offsetY - pointerOffset,
        transform: t
      };
      break;
    case "topCentered":
      y = pos.y;
      x = pos.x + dim.w / 2;
      t = `translate(-50%, calc(-100% + -${dim.h}px))`;
      positionStyles = {
        top: y,
        left: x,
        marginLeft: offsetX,
        marginTop: offsetY - pointerOffset,
        transform: t
      };
      break;
    case "modalTop":
      y = pos.y;
      positionStyles = {
        top: y
      };
      break;
    case "bottomRight":
      y = pos.y + dim.h;
      x = bodyDim.w - (pos.x + dim.w);
      positionStyles = {
        top: y,
        right: x,
        marginRight: offsetX,
        marginTop: offsetY + pointerOffset
      };
      break;
    case "bottomCentered":
      y = pos.y + dim.h;
      x = pos.x + dim.w / 2;
      positionStyles = {
        top: y,
        left: x,
        marginLeft: offsetX,
        marginTop: offsetY + pointerOffset
      };
      break;
    case "modalBottom":
      y = pos.y;
      t = `translateY(-100%)`;
      positionStyles = {
        top: y,
        transform: t
      };
      break;
    default:
      // bottomLeft
      y = pos.y + dim.h;
      x = pos.x;
      positionStyles = {
        top: y,
        left: x,
        marginLeft: offsetX,
        marginTop: offsetY + pointerOffset
      };
  }
  return positionStyles;
};
exports.setFlyoutPosition = setFlyoutPosition;
const handleFocusElement = elemRef => {
  if (elemRef && elemRef.current) {
    elemRef.current.focus();
  }
};
exports.handleFocusElement = handleFocusElement;